import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';

import { createSlice } from 'utils/@reduxjs/toolkit';
import { organisationUiSaga } from './saga';

import {
  sliceLoadFail,
  sliceSpecialLoadFail,
  sliceSpecialLoadHandle,
} from 'utils/tools/slice-actions';

export const initialState = {
  loading: false,
  error: null,
  organisationUiDetails: {},
};

export const OrganisationUiActionTypes = {
  FETCH_ORG_UI_DETAILS: 'fetchOrgUiDetails',
  MANAGE_ORG_UI_DETAILS: 'manageOrgUiDetails',
};

const slice = createSlice({
  name: 'OrganisationUi',
  initialState,
  reducers: {
    fetchOrgUiDetailsStart(state, action) {
      sliceSpecialLoadHandle(state, action?.payload?.actionFor, true);
    },

    fetchDashboardDataStartSuccess(state, action) {
      console.log('action', action);
      state.OrganisationUiDetails = action?.payload;
      state.loading = false;
    },

    manageOrgUiDetailsStart(state, action) {
      sliceSpecialLoadHandle(state, action?.payload?.actionFor, true);
    },

    fetchActionError(state, action) {
      sliceLoadFail(state, action);
    },

    // Update actions
    updateActionEnd(state, action) {
      const { actionFor, data = null, responseData } = action.payload;
      sliceSpecialLoadHandle(
        state,
        actionFor,
        false,
        data,
        undefined,
        undefined,
        undefined,
        undefined,
        responseData,
      );
    },
    updateActionError(state, action) {
      const { actionFor, error, responseData } = action.payload;
      sliceSpecialLoadFail(state, actionFor, error, responseData);
    },

    fetchPageActionEnd(state, action) {
      const { actionFor, data, page_number, page_size, total, searchValue } =
        action.payload;
      sliceSpecialLoadHandle(
        state,
        actionFor,
        false,
        data,
        page_number,
        page_size,
        total,
        searchValue,
      );
    },
    fetchPageActionError(state, action) {
      const { actionFor, error } = action.payload;
      sliceSpecialLoadFail(state, actionFor, error);
    },
  },
});

export const { actions: organisationUiActions } = slice;

export const useOrganisationUiSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: organisationUiSaga });
  return { actions: slice.actions };
};
